import React, { Component } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';
import env from 'config/env';
import fileDownload from 'js-file-download';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as types from 'constants/actionTypes';
import LOOKUP from 'constants/lookup';
import { patientListCrumb } from 'utils/breadcrumbInfo';
import { mapPatients, mapPatientsNoRewards } from "utils/mappers";
import { clearFormInput } from 'actions/FormActions';
import { addToCheckIn, getCheckIn, cleanAddCheckIn, mergeMember } from 'actions/EntityActions';
import { showError, showSnackbar, handleCheckInDialog } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
import { getToken } from 'selectors/tokenSelector';
// Basic Components
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';
import TextInput from 'screens/components/basic/TextInput';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import SearchFields from './components/searchFields';

const pageName = "patientList";

const loadDialogStyle = {
    maxWidth: 'none',
    minWidth: 'none',
    zIndex: '999999999'
};

const loadDialogcustomContentStyle = {
    width: '580px',
    maxWidth: 'none'
};

//Component for the listing of Patients
class PatientList extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            status: 'None',
            orderBy: 'DESC',
            sortBy: 'Id',
            loading: false,
            showMergeDialog: false
        };
        
        this.search = this.search.bind(this);
        this.cleanSearch = this.cleanSearch.bind(this);
        this.sort = this.sort.bind(this);
        this.changePage = this.changePage.bind(this);
        this.openMergeMemberDialog = this.openMergeMemberDialog.bind(this);
        this.addToCheckIn = this.addToCheckIn.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
    }

    //Call the init which will call API to retrive the list of patients
    componentWillMount() {
        if (!this.props.memberEnabled) {
            this.props.showError(LOOKUP.authentication.unauthorizedMessage);
            this.props.navigate('/');
        }
        this.cleanSearch();
        this.getPatients();
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.checkInSuccess != undefined && newProps.checkInSuccess !== this.props.checkInSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.checkInSuccess) {
                this.saveSuccess();
            }
            else {
                this.saveFailure();
            }
        }

        if (newProps.memberMergeSuccess != undefined && newProps.memberMergeSuccess !== this.props.memberMergeSuccess) {
            this.getPatients();
            this.props.showSuccess("Members have been merged.");
        }
    }

    changePage(e) {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getPatients);
    }

    getPatients() {
        this.props.init({
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            firstName: this.props.firstNameFilter ? this.props.firstNameFilter : "",
            lastName: this.props.lastNameFilter ? this.props.lastNameFilter : "",
            cardNumber: this.props.cardNumberFilter ? this.props.cardNumberFilter : "",
            id: this.props.memberNumberFilter ? this.props.memberNumberFilter : 0,
            status: this.props.patientStatusFilter ? this.props.patientStatusFilter : "None",
            careGiver: this.props.patientCareGiver ? this.props.patientCareGiver : "",
            phone: this.props.patientPhone ? this.props.patientPhone : "",
            email: this.props.patientEmail ? this.props.patientEmail : "",
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            branchId: this.props.branchId,
            eliteStatus: this.props.eliteFilter ? this.props.eliteFilter : 0
        });
    }

    search() {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getPatients);
    }

    cleanSearch() {
        this.props.clearFormInput(`${pageName}MemberNumberFilter`);
        this.props.clearFormInput(`${pageName}FisrtNameFilter`);
        this.props.clearFormInput(`${pageName}LastNameFilter`);
        this.props.clearFormInput(`${pageName}CardNumberFilter`);
        this.props.clearFormInput(`${pageName}Status`);
        this.props.clearFormInput(`${pageName}CareGiver`);
        this.props.clearFormInput(`${pageName}PhoneNumber`);
        this.props.clearFormInput(`${pageName}Email`);
        this.props.clearFormInput(`${pageName}MemberIdMain`);
        this.props.clearFormInput(`${pageName}MemberIdMerge`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "Id",
                orderBy: "DESC"
            };
        }, () => this.getPatients());
    }

    handleChange(value) {
        this.setState(pState => {
            return {
                ...pState,
                value: value
            };
        }, () => this.setStatus(value));
    }

    /**
     * String {status} - can be Active or Inactive.
     */
    setStatus(status) {
        if (status && status === 'Active' || status === 'Inactive') {
            this.setState(prevState => {
                return {
                    ...prevState,
                    status: status,
                    activePage: 1
                };
            }, this.getPatients);
        }

    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getPatients);
    }

    addToCheckIn(id) {
        this.props.addToCheckIn(id);
    }

    //when data is saved successfully
    saveSuccess() {
        this.props.showSuccess("Member added successfully to Check-in list");
        this.props.cleanAddCheckIn();
    }

    saveFailure() {
        this.props.cleanAddCheckIn();
    }

    mergeMember() {
        let model = {
            memberMain: ~~this.props.memberMain,
            memberMerge: ~~this.props.memberMerge,
            branchId: this.props.branchId
        }
        this.closeMergeMemberDialog();
        this.props.mergeMember(model);
    }

    openMergeMemberDialog() {
        this.setState({ ...this.state, showMergeDialog: true });
    }

    closeMergeMemberDialog() {
        this.setState({ ...this.state, showMergeDialog: false }, () => {
            this.props.clearFormInput(`${pageName}MemberIdMain`);
            this.props.clearFormInput(`${pageName}MemberIdMerge`);
        })
    }

    downloadReport() {
        let url = `reports/excel/memberlist`;
        let name = "MemberList";
        
        let token = getToken();

        const headers = {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'timezone_offset': new Date(Date.now()).getTimezoneOffset()
        }
        this.setState({ loading: true });
        Axios.get(`${env.reportsAPIUrl()}${url}`, { headers: headers })
            .then(r => {
                fileDownload(r.data, `${name}.csv`);
                this.setState({ loading: false });
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
            });
    }

    render() {
        const p = this.props;
        const s = this.state;

        const hideBCRewards = this.props.store && this.props.store.provinceState && (this.props.store.provinceState.toLowerCase() == "bc" || this.props.store.provinceState.toLowerCase() == "british columbia") && !this.props.isMedical;
        const showRewards = !(this.props.springbigApiKey || this.props.alpineIQApiKey || hideBCRewards);

        return (
            <Grid headerContent={patientListCrumb}>
                <PageHeaderWithButton title={LOOKUP.patient.listTitle}>
                <Button
                        type="SaveButton"
                        mini={true}
                        label="DOWNLOAD"
                        className="bg-purple mr-2"
                        onTouchTap={this.downloadReport} />
                    <Button
                        type="SearchButton"
                        mini={true}
                        label="Merge member"
                        className="bg-purple mr-2"
                        onTouchTap={this.openMergeMemberDialog} />
                    <Button
                        type="AddButton"
                        mini={true}
                        label="ADD NEW MEMBER"
                        className="bg-light-green"
                        onTouchTap={() => window.location = "/member/add"} />
                </PageHeaderWithButton>
                <SearchFields pageName={pageName} cleanSearch={this.cleanSearch} search={this.search} isMedical={this.props.isMedical} isHighTide={this.props.isHighTide} />
                <CardSimple>
                    <GenericTable
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        columns={showRewards ? LOOKUP.patient.tableColumns : LOOKUP.patient.tableColumnsNoRewards}
                        rows={showRewards ? mapPatients(p.patients, this.addToCheckIn, p.isMedical, p.rewardPointsDivider) : mapPatientsNoRewards(p.patients, this.addToCheckIn, p.isMedical)}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <Pagination
                        length={p.patientListLength || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={this.changePage}
                        maxButtons={4}
                    />
                </CardSimple>
                <Dialog
                    modal={true}
                    open={this.state.loading}
                    contentStyle={loadDialogcustomContentStyle}
                    style={loadDialogStyle}>
                    <div className="loading">
                        <CircularProgress size={50} />
                        <br />
                        <h4 className="text-center">Downloading Members</h4>
                    </div>
                </Dialog>
                <Dialog
                    modal={true}
                    open={this.state.showMergeDialog}
                    contentStyle={loadDialogcustomContentStyle}
                    title={"MERGE MEMBER"}
                    style={loadDialogStyle}
                    titleStyle={{ textAlign: 'center' }}>

                    <DialogContent >
                        <div className="loading">
                            <h5>Please type the member Id for the main member and the member to merge</h5>
                            <TextInput
                                type="number"
                                name={`${pageName}MemberIdMain`}
                                className="search-field"
                                label={LOOKUP.patient.dialogMemberMerge.memberMain}
                                floatingLabelText={LOOKUP.patient.dialogMemberMerge.memberMain}
                                hintText={LOOKUP.patient.dialogMemberMerge.memberMain}
                                maxLength={20}
                            />
                            <TextInput
                                type="number"
                                name={`${pageName}MemberIdMerge`}
                                className="search-field"
                                label={LOOKUP.patient.dialogMemberMerge.memberMerge}
                                floatingLabelText={LOOKUP.patient.dialogMemberMerge.memberMerge}
                                hintText={LOOKUP.patient.dialogMemberMerge.memberMerge}
                                maxLength={20}
                            />
                            <br />
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeMergeMemberDialog()}
                        />,
                        <Button
                            key={3}
                            type="SaveButtonNoIcon"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={"Merge"}
                            onTouchTap={() => this.mergeMember()}
                        />
                    </DialogActions>

                </Dialog>
            </Grid>);
    }
}

function mapStateToProps(state) {
    return {
        patients: state.entity.patientList,
        patientListLength: state.entity.patientListLength,
        firstNameFilter: state.form[`${pageName}FisrtNameFilter`],
        lastNameFilter: state.form[`${pageName}LastNameFilter`],
        memberNumberFilter: state.form[`${pageName}MemberNumberFilter`],
        cardNumberFilter: state.form[`${pageName}CardNumberFilter`],
        patientStatusFilter: state.form[`${pageName}Status`],
        patientCareGiver: state.form[`${pageName}CareGiver`],
        patientPhone: state.form[`${pageName}PhoneNumber`],
        patientEmail: state.form[`${pageName}Email`],
        memberMain: state.form[`${pageName}MemberIdMain`],
        memberMerge: state.form[`${pageName}MemberIdMerge`],
        memberMergeSuccess: state.form.MemberMergeSuccess,
        checkInSuccess: state.entity.addCheckIn,
        memberEnabled: state.common.applicationSettings.memberEnabled,
        isMedical: state.common.applicationSettings.isMedical,
        store: state.common.store,
        branchId: state.common.branchId,
        alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey,
        springbigApiKey: state.common.applicationSettings.springbigApiKey,
        rewardPointsDivider: state.common.applicationSettings.rewardPointsDivider,
        eliteFilter: state.form[`${pageName}EliteFilter`],
        isHighTide: state.common.applicationSettings.isHighTide,
        hideRewards: state.common.applicationSettings.hideRewards
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (model) => dispatch({ type: types.PATIENT_LIST_LOAD, model }),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        addToCheckIn: (id) => dispatch(addToCheckIn(id)),
        handleCheckInDialog: () => dispatch(handleCheckInDialog()),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        getCheckIn: model => dispatch(getCheckIn(model)),
        mergeMember: model => dispatch(mergeMember(model)),
        cleanAddCheckIn: () => dispatch(cleanAddCheckIn()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PatientList));
